import React from "react";
import Link from "next/link";
const PotentialSection = ({ setSnpKitPopup, scrollhandleClick }) => {
    return (
        <>
            <div className="cmn-heading-wrap">
                <h2 className="genertic-potential-heading">Harness Your Genetic Potential: </h2>
                <h2>Turn Your DNA Data Into Personalized Nutrition </h2>
            </div>

            <div className="third-section-main">
                <div className="third-left-section">
                    <div className="third-section-right-image">
                        <img src="/images/third_section_image_cmp.jpg" />
                    </div>
                    <p>You've already done your part with a third-party DNA test, now let us help you put that investment to good use. </p>

                    <h4>Here’s how it works:</h4>

                    <p>On the next page you will be guided through the process of safely and securely entering your DNA data for <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => setSnpKitPopup(true)}>these 22 heavy hitting SNPs</a> into our system. </p>

                    {/* <span className="txt-undrline">these 19+ heavy hitting SNPs</span> */}

                    <p>Once you hit “submit,” your Premium C.O.D.E. Report, Summary DNA Health Report, and personalized Supplement Facts Panel (SFP) – <em>customized from over 3 billion possible combinations</em> – will be electronically generated and available in your private, password-protected SNiP account.
                    </p>
                </div>

            </div>
            <h4>You will receive your:</h4>
            {/*  <p><span className="txt-undrline">Premium C.O.D.E. Report</span> - A detailed analysis of 22 key SNPs that impact nearly every facet of your health and longevity. Learn which nutrients your body uniquely needs and why. Includes tailored, science-backed guidance on nutrition, exercise, sleep,
                and other lifestyle recommendations based on your personal genetic blueprint. View a sample of
                this premium report <a href="https://www.snipnutrition.net/samplecodereport">here.</a>
            </p>*/}
            <p><span className="txt-undrline">Premium C.O.D.E. Report</span> - A deep-dive into 22 key SNPs, detailing their impact on your health and
                longevity. This report reveals the specific nutrients to optimize your genetic expression. Additional actionable
                guidance on diet, exercise, sleep, and lifestyle adjustments based on your unique genetic profile are also included.
            </p>
            <p><span className="txt-undrline">Summary DNA Health Report</span> - Highlighting key health areas impacted by your specific genetic variants for which your DNA-personalized nutrition is designed to support.</p>

            <p><span className="txt-undrline">Personalized Supplement Facts panel (SFP)</span> - Revealing your truly personalized <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> formulation, including the specific, science-backed ingredients shown to support your genetic vulnerabilities in 10+ key health areas.</p>

            <p>At this point, we’ll have everything we need to formulate your custom <Link href="#nutrition-section" style={{ cursor: 'pointer' }}>CODE Complex™</Link> formula!</p>

            <p>Simply choose between a one-time order for $179 or a monthly subscription for $159 (<em>which you can cancel or modify anytime</em>). </p>

            <p>...And your precision supplement will custom-compound and ship directly to your doorstep within 21 business days.</p>

            <p>Click the DNA Test Provider below whose data you’d like to use to start optimizing your health, happiness, and longevity!</p>
        </>
    )
}

export default PotentialSection;